import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=6a1cf7ea&scoped=true"
import script from "./DefaultTemplate.vue?vue&type=script&lang=ts"
export * from "./DefaultTemplate.vue?vue&type=script&lang=ts"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=6a1cf7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1cf7ea",
  null
  
)

export default component.exports